import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { CampaignsState } from "../actions/campaigns"

interface IPayloadOpenDrawer {
	isEditMode: boolean
	campaign?: CampaignsState | undefined
	tabIndex?: number
}

export interface ICampaignEditState {
	isDrawerOpen: boolean
	isEditMode: boolean
	currentCampaign: CampaignsState | undefined
	tabIndex: number
}

const initialState: ICampaignEditState = {
	isDrawerOpen: false,
	isEditMode: false,
	tabIndex: 0,
	currentCampaign: undefined,
}

const campaignEditSlice = createSlice({
	name: "campaignEdit",
	initialState,
	reducers: {
		openDrawer: (
			state: ICampaignEditState,
			action: PayloadAction<IPayloadOpenDrawer>
		) => {
			state.isDrawerOpen = true
			state.isEditMode = action.payload.isEditMode || false
			state.currentCampaign = action.payload.campaign || undefined
			state.tabIndex = action.payload.tabIndex || 0
		},
		closeDrawer: (state) => {
			state.isDrawerOpen = false
			state.isEditMode = false
			state.currentCampaign = undefined
		},
	},
})

export const { openDrawer, closeDrawer } = campaignEditSlice.actions
export default campaignEditSlice.reducer
